
import { Rating } from '../types'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CampsiteDetails } from '~/apps/campsite-details/types'

@Component
export default class BookingCampsiteDetails extends Vue {
  @Prop()
    address: string

  @Prop()
    campsiteName: string

  @Prop()
    photo: CampsiteDetails['primaryPhoto']

  @Prop()
    photoCaption: string

  @Prop()
    rating: Rating

  @Prop()
    lastBooked: string

  @Prop()
    prettyId: string

  @Prop({ default: false })
    summaryView: boolean
}
